/* eslint-disable react/prefer-stateless-function */

import React from 'react';

import ICO_CLOSE from 'assets/images/btn-close.svg';

class ModalHeader extends React.Component {
  static defaultProps = {
    children: [],
  };

  render() {
    const { onClose, style } = this.props;
    return (
      <div className="modal-header" style={style}>
        <div className="close" role="button" tabIndex={0} onClick={onClose}>
          <img src={ICO_CLOSE} alt="" />
        </div>
        {this.props.children}
      </div>
    );
  }
}

export default ModalHeader;
